// Trimmed list of common countries. Extend as needed.
export const COUNTRIES = [
  'United States','United Kingdom','Canada','Australia','New Zealand','Ireland','Germany','France','Spain','Portugal',
  'Italy','Netherlands','Belgium','Switzerland','Austria','Sweden','Norway','Denmark','Finland','Iceland',
  'Poland','Czech Republic','Hungary','Romania','Bulgaria','Greece','Turkey','Russia','Ukraine','Belarus',
  'United Arab Emirates','Saudi Arabia','Qatar','Kuwait','Bahrain','Oman','Israel','Jordan','Lebanon','Egypt',
  'South Africa','Nigeria','Kenya','Ghana','Morocco','Tunisia','Algeria','Ethiopia','Tanzania','Uganda',
  'India','Pakistan','Bangladesh','Sri Lanka','Nepal','Bhutan','Maldives',
  'China','Japan','South Korea','Taiwan','Hong Kong','Singapore','Malaysia','Thailand','Vietnam','Philippines','Indonesia','Cambodia','Laos','Myanmar',
  'Mexico','Brazil','Argentina','Chile','Colombia','Peru','Venezuela','Ecuador','Uruguay','Paraguay','Bolivia','Costa Rica','Panama','Dominican Republic','Puerto Rico',
  'Cyprus','Malta','Luxembourg','Monaco','Andorra','Liechtenstein','Slovenia','Slovakia','Croatia','Serbia','Estonia','Latvia','Lithuania',
  'Kazakhstan','Uzbekistan','Azerbaijan','Georgia','Armenia',
  'Other'
];
